import { render, staticRenderFns } from "./ApprovalLog.vue?vue&type=template&id=49a17068&scoped=true&"
import script from "./ApprovalLog.vue?vue&type=script&lang=js&"
export * from "./ApprovalLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a17068",
  null
  
)

export default component.exports